import { render, staticRenderFns } from "./TermAssurancePlan.vue?vue&type=template&id=3b3c6576&scoped=true"
import script from "./TermAssurancePlan.vue?vue&type=script&lang=js"
export * from "./TermAssurancePlan.vue?vue&type=script&lang=js"
import style0 from "./TermAssurancePlan.vue?vue&type=style&index=0&id=3b3c6576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c6576",
  null
  
)

export default component.exports